module.exports = __webpack_public_path__ + "img/imggroup.738953d1.jpg";